<template>

            <div class="titulo">
                <div class="margem container">
                    <div class="m-icone direita"><button @click="verPCMCriada('Programa')" class="acao-secundaria">Novo
                            Programa</button></div>
                    <div class="m-icone direita">
                        <div class="pesquisa">
                            <input type="text" placeholder="Pesquisar Programa" v-model="programaSelecionado"
                                @input="filtrarProgramas()" />
                            <a disabled class="icone-pesquisa"></a>
                        </div>
                    </div>
                    <h2>Programas</h2>
                </div>
            </div>
            <div class="margem container">
                <div class="bloco margem">
                    <table class="tabela">
                        <tbody>
                            <tr>
                                <th scope="col">Nome do Programa</th>
                                <th scope="col">Status</th>
                                <th scope="col">Data de Inicio</th>
                                <th scope="col">Data de Término</th>
                                <th scope="col">Gerente Responsável</th>
                                <th scope="col"></th>
                            </tr>
                            <tr v-for="item in listaProgramasFiltrada"
                                style="background-color: transparent;text-align: center;" :key="item.id"
                                @mouseover="mostrarBotao(item.id, true)" @mouseleave="mostrarBotao(item.id, false)"
                                @click="goToProjetos(item.id)">
                                <td style="vertical-align: middle;">{{ item.nome }}</td>
                                <td class="clicavel"
                                    style="vertical-align: middle; display: flex; align-items: center; justify-content: center; border: none">
                                    <select v-model="item.status" class="form-select"
                                        :style="{ 'color': (item.status === 'Aprovado') ? '#00B6B3' : (item.status === 'Em andamento') ? 'var(--cor-ok)' : (item.status === 'Concluído') ? ' var(--cor-sucesso)' : '#FFA500', }"
                                        style="width: 10rem; outline: none; text-align: center; border: none; "
                                        @click.stop @change="editarProgramaInline(item.id, 'status', item.status)">
                                        <option style="color: #00B6B3;">Aprovado</option>
                                        <option style="color: var(--cor-ok);">Em andamento</option>
                                        <option style="color: var(--cor-sucesso);">Concluído</option>
                                        <option style="color: #FFA500;">Suspenso</option>
                                    </select>
                                </td>
                                <td style="vertical-align: middle;">{{ formatarDataBr(item.dtInicio, '') }}</td>
                                <td style="vertical-align: middle;">{{ formatarDataBr(item.dtTermino) }}</td>
                                <td style="vertical-align: middle;">{{ item.gerente_nome }}</td>
                                <td style="vertical-align: middle;">
                                    <div style="width: max-content; visibility: hidden;" :id="'botaoEdicao' + item.id">
                                        <v-menu v-if="Array.isArray(programas) && programas.length > 0">
                                            <template v-slot:activator="{ props }">
                                                <v-btn
                                                    style="width: 2rem; height: 2rem; border: 1px solid var(--cor-separador); color: var(--cor-fonte);"
                                                    class="botaoAdicionarSprint acao-secundaria"
                                                    icon="mdi-dots-horizontal" v-bind="props"></v-btn>
                                            </template>

                                            <v-list style="background-color: var(--cor-bg); color: var(--cor-fonte);">
                                                <v-list-item @click="programasAssociados(item.id)">
                                                    Associar projetos
                                                </v-list-item>
                                                <v-list-item :disabled="!item.pcm_id" @click="this.$router.push(`/PCM/${item.pcm_id}`)">
                                                    Plano de Programa
                                                </v-list-item>
                                                <v-list-item
                                                    @click="abrirModalEditarPrograma(item)">
                                                    Editar dados
                                                </v-list-item>
                                                <v-list-item
                                                    @click="modalFinalizarPrograma = true, this.programaEditado = item">
                                                    Finalizar
                                                </v-list-item>
                                                <v-list-item style="color: var(--cor-erro);"
                                                    @click="modalExcluirPrograma = true, this.programaEditado = item">
                                                    Excluir
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="loading" v-if="!programas">
                        <div></div>
                    </div>
                </div>
            </div>

            <ModalFinalizarPrograma :mostrar="modalFinalizarPrograma" :programa-nome="programaEditado?.nome ?? ''"
                @fechar="fecharTodosModais" @finalizar="finalizarPrograma" />
            <ModalExcluirPrograma :mostrar="modalExcluirPrograma" :programa-nome="programaEditado?.nome ?? ''"
                @fechar="fecharTodosModais" @confirmar="excluirPrograma" />
            <ModalEditarPrograma :mostrar="modalEditarPrograma" :programa="programaEditado" :gerente="gerente"
                @fechar="fecharTodosModais" @editar="editarPrograma" />
            <ModalProjetosAssociados :mostrar="modalProjetosAssociados" :programa="programaEditado ?? {}"
                :projetos="projetos" :planos-acao="planosAcao"
                @fechar="fecharTodosModais" @associar-projeto="associarProjeto" @associar-plano-acao="associarPlanoAcao"
                @desassociar="desassociarPlano" />
            <ModalNovoPrograma :mostrar="modalNovoPrograma" :gerente="gerente"
                @fechar="fecharTodosModais" @salvar="adicionarProgramaPayload" />

</template>


<script>
import { useApiError } from "@/composables/useApiError";
import { getDados } from "@/services/serviceFuncionalidades";
import { consultarSetores } from "@/services/usuario-setor";
import { sso } from "roboflex-thalamus-sso-lib";
import { formatarDataBr, dataParaInput } from "@/utils/date";
import {
    listarProgramas,
    buscarPrograma,
    cadastrarPrograma,
    atualizarPrograma,
    excluirPrograma,
    associarAoPrograma,
    desassociarDoPrograma,
    listarProjetosPlanoSemPrograma,
} from "@/services/serviceProgramas";
import ModalFinalizarPrograma from "@/components/Modais/Programas/ModalFinalizarPrograma.vue";
import ModalExcluirPrograma from "@/components/Modais/Programas/ModalExcluirPrograma.vue";
import ModalEditarPrograma from "@/components/Modais/Programas/ModalEditarPrograma.vue";
import ModalProjetosAssociados from "@/components/Modais/Programas/ModalProjetosAssociados.vue";
import ModalNovoPrograma from "@/components/Modais/Programas/ModalNovoPrograma.vue";

export default {
    name: "ControleProgramas",
    components: {
        ModalFinalizarPrograma,
        ModalExcluirPrograma,
        ModalEditarPrograma,
        ModalProjetosAssociados,
        ModalNovoPrograma,
    },
    setup() {
        const { handleError } = useApiError();
        return { formatarDataBr, dataParaInput, handleApiError: handleError };
    },

    data() {
        return {
            dadosUsuario: this.carregarPermissoes(),
            idUsuario: null,

            programaSelecionado: null,
            listaProgramasFiltrada: null,

            modalProjetosAssociados: false,
            modalNovoPrograma: false,
            modalExcluirPrograma: false,
            programas: null,
            gerente: [],
            modalEditarPrograma: false,
            programaEditado: null,
            projetos: [],
            planosAcao: [],
            modalFinalizarPrograma: false
        }
    },

    mounted() {
        this.getProgramas()
        this.getGerente()
        this.getProjetosPlanoAcao()
    },

    created() {
        const usuarioLogado = sso.getUsuarioLogado()
        // this.userName = usuarioLogado.nome // nome
        this.idUsuario = usuarioLogado.id // id
    },

    methods: {
        goToProjetos(id) {
            this.$router.push({ name: "controleDeProjetos", params: { id: id } })
        },
        verPCMCriada(tipo, nivel) {
            localStorage.setItem('Tipo', tipo);
            localStorage.setItem('Nivel', nivel)
            if (this.$route.path === '/PCM/Criar') {
                window.location.reload();
            } else {
                this.$router.push({ name: "CriarPCM" });
            }
        },

        carregarPermissoes() {
            getDados(this.idUsuario)
                .then(dadosUsuario => {
                    this.dadosUsuario = dadosUsuario;
                })
                .catch((error) => {
                    this.handleApiError(error);
                });
        },

        async finalizarPrograma(dataTermino) {
            try {
                await atualizarPrograma(this.programaEditado.id, {
                    dtFim: dataTermino,
                    status: "Concluído",
                });
                this.modalFinalizarPrograma = false;
                await this.getProgramas();
            } catch (error) {
                this.handleApiError(error);
            }
        },

        filtrarProgramas() {
            if (!this.programaSelecionado) {
                this.listaProgramasFiltrada = this.programas;
            } else {
                const textoLowerCase = this.programaSelecionado.toLowerCase();
                this.listaProgramasFiltrada = this.programas.filter(programa => {
                    return Object.values(programa).some(value => {
                        if (typeof value === 'string') {
                            return value.toLowerCase().includes(textoLowerCase);
                        }
                        return false;
                    });
                });
            }
        },

        fecharTodosModais() {
            this.modalProjetosAssociados = false;
            this.modalNovoPrograma = false;
            this.modalEditarPrograma = false;
            this.modalExcluirPrograma = false;
            this.modalFinalizarPrograma = false;
        },

        async excluirPrograma() {
            try {
                await excluirPrograma(this.programaEditado.id, this.idUsuario);
                await this.getProgramas();
                this.modalExcluirPrograma = false;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async associarProjeto(event) {
            const projetoId = Number(event.target.value);
            if (!projetoId) return;
            try {
                const res = await associarAoPrograma(this.programaEditado.id, projetoId, true);
                this.programaEditado.projeto.push({
                    associacao_id: res.associacao_id,
                    projeto_nome: event.target.options[event.target.selectedIndex].text,
                });
                await this.getProjetosPlanoAcao();
            } catch (error) {
                this.handleApiError(error);
            }
            event.target.value = "";
        },

        async associarPlanoAcao(event) {
            const planoAcaoId = Number(event.target.value);
            if (!planoAcaoId) return;
            try {
                const res = await associarAoPrograma(this.programaEditado.id, planoAcaoId, false);
                this.programaEditado.planoAcao.push({
                    associacao_id: res.associacao_id,
                    planoAcao_nome: event.target.options[event.target.selectedIndex].text,
                });
                await this.getProjetosPlanoAcao();
            } catch (error) {
                this.handleApiError(error);
            }
            event.target.value = "";
        },

        async desassociarPlano(tipo, id) {
            const ehProjeto = tipo === "projeto";
            try {
                await desassociarDoPrograma(this.programaEditado.id, id, ehProjeto);
                if (ehProjeto) {
                    this.programaEditado.projeto = this.programaEditado.projeto.filter((p) => p.associacao_id !== id);
                } else {
                    this.programaEditado.planoAcao = this.programaEditado.planoAcao.filter((p) => p.associacao_id !== id);
                }
                await this.getProjetosPlanoAcao();
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getProjetosPlanoAcao() {
            try {
                const data = await listarProjetosPlanoSemPrograma();
                this.projetos = data.projeto;
                this.planosAcao = data.planoAcao;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async programasAssociados(id) {
            try {
                this.programaEditado = await buscarPrograma(id);
                this.modalProjetosAssociados = true;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        mostrarBotao(id, mostrar) {
            if (mostrar === true) {
                document.getElementById('botaoEdicao' + id).style.visibility = ''
            }
            if (mostrar === false) {
                document.getElementById('botaoEdicao' + id).style.visibility = 'hidden'
            }
        },

        async editarPrograma(itemAlterado, novoValor) {
            try {
                await atualizarPrograma(this.programaEditado.id, { [itemAlterado]: novoValor });
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async editarProgramaInline(idProjeto, itemAlterado, novoValor) {
            try {
                const payload = novoValor === "Concluído"
                    ? { [itemAlterado]: novoValor, dtFim: new Date().toISOString().split("T")[0] }
                    : { [itemAlterado]: novoValor, dtTermino: null };
                await atualizarPrograma(idProjeto, payload);
                await this.getProgramas();
            } catch (error) {
                this.handleApiError(error);
            }
        },

        abrirModalEditarPrograma(item) {
            this.programaEditado = { ...item };
            this.programaEditado.dtFim = item.dtFim ? dataParaInput(item.dtFim) : "";
            this.programaEditado.dtInicio = item.dtInicio ? dataParaInput(item.dtInicio) : "";
            this.modalEditarPrograma = true;
        },

        async adicionarProgramaPayload(payload) {
            try {
                await cadastrarPrograma({
                    nome: payload.nome,
                    dtInicio: payload.dtInicio,
                    dtFim: payload.dtFim,
                    gerente_id: payload.gerente_id,
                    setor_id: payload.setor_id,
                });
                await this.getProgramas();
                this.modalNovoPrograma = false;
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getProgramas() {
            try {
                this.programas = await listarProgramas();
                this.filtrarProgramas();
            } catch (error) {
                this.handleApiError(error);
            }
        },

        async getGerente() {
            try {
                const { usuarios } = await consultarSetores();
                this.gerente = usuarios;
            } catch (error) {
                this.handleApiError(error);
            }
        },


        verPCM() {
            this.$router.push({ name: "PCM" })
        },

    }

}
</script>

<style scoped></style>